import './App.css';
import Navbar from './components/Navbar';
import Form from './components/Form'
import About from './components/About';

function App() {
  return (
    <div>
<Navbar/>
<div className="container">
<Form/>
</div>
</div>
  );
}

export default App;
